import { useState } from 'react';
import type { TranscriptSegment } from '@marnic/shared';

function fmt(ms: number): string {
  const total = Math.floor(ms / 1000);
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}

export function TranscriptDrawer({ segments }: { segments: TranscriptSegment[] }): JSX.Element | null {
  const [open, setOpen] = useState(false);
  if (segments.length === 0) return null;
  return (
    <details
      className="text-xs"
      open={open}
      onToggle={(e) => setOpen((e.currentTarget as HTMLDetailsElement).open)}
    >
      <summary className="cursor-pointer text-[11px] text-ink-500 hover:text-ink-700">
        {open ? 'Hide transcript' : `View transcript (${segments.length} lines)`}
      </summary>
      <div className="mt-2 max-h-72 overflow-y-auto rounded bg-ink-50 p-2">
        <ol className="space-y-1.5 text-xs">
          {segments.map((s, idx) => (
            <li key={idx} className="flex gap-2">
              <span
                className={`shrink-0 font-mono text-[10px] uppercase ${
                  s.speaker === 'agent' ? 'text-sky-700' : 'text-fuchsia-700'
                }`}
              >
                {s.speaker} {fmt(s.startMs)}
              </span>
              <span className="whitespace-pre-wrap">{s.text}</span>
            </li>
          ))}
        </ol>
      </div>
    </details>
  );
}
